// extracted by mini-css-extract-plugin
export default {"loadingImage":"LoadingPageContent_loadingImage__CNi30","loadingTitle":"LoadingPageContent_loadingTitle__ZIMbt","loadingSpinner":"LoadingPageContent_loadingSpinner__epDHF"};